import React, { useEffect, useState } from 'react';
import axios from 'axios'
import { Panel, PanelHeader, PanelBody } from '../../components/panel/panel.jsx';
import { toast } from 'react-toastify';
import Select, { components } from 'react-select';
import { isEmpty } from "../../helper/helper.js"

function CourierServiceTypeForm({ props = {} }) {
  const [appData, setAppData] = useState({ active: true })
  const [formData, setFormData] = useState({ mCourier: [], mServiceType: [] })

  const handleOnChangeInputText = (e) => {
    const { name, value } = e.target
    setAppData(prevState => ({
      ...prevState,
      [name]: value
    }))
  }

  const handleOnChangeSelect = (option, e) => {
    if (option) {
      if (e.action === "select-option") {
        setAppData(prevState => ({
          ...prevState,
          [e.name]: option.value,
        }))
      } else {
        setAppData(prevState => ({
          ...prevState,
          [e.name]: '',
        }))
      }
    }
  }

  // Custom Option component for the dropdown menu
  const CustomOption = (props) => {
    return (
      <components.Option {...props}>
        <div><span className='fw-bold fs-6 text-red'>{props.data?.value}</span> - <span className='fw-bold fs-6'>{props.data?.label}</span></div>
      </components.Option>
    );
  };

  const saveAction = async (e) => {
    e.preventDefault()

    let payload = {
      courier: appData.courierCode,
      serviceType: appData.serviceType,
      serviceCode: appData.serviceCode, 
      active: appData.active,
    }

    /**
     * check / validate data 
     */

    if (isEmpty(appData.courierCode)) {
      toast.error('Courier Code is required')
      return
    }

    if (isEmpty(appData.serviceType) || isEmpty(appData.serviceCode)) {
      toast.error('Service Type / Service Code is required')
      return
    }
 

    if (!props.uid) {
      // New 
      await axios.post(`${window.API_HOST}/v1/courier-service-type`, payload).then(async (res) => {
        const resp = res.data
        setAppData(prevState => ({
          ...prevState,
          uid: resp.data.id,
          updated_at: resp.data.updated_at,
          updated_by: resp.data.updated_by
        }))
        props.uid = resp.data.uid
        toast.success(`Success save Courier status ${appData.courierCode} / ${appData.serviceType} / ${appData.serviceCode}`)
      }).catch(err => {
        toast.error(err.response.data.error)
      })
    } else {

      //Update
      await axios.put(`${window.API_HOST}/v1/courier-service-type/${props.uid}`, payload).then(async (res) => {
        const resp = res.data
        setAppData(prevState => ({
          ...prevState,
          updated_at: resp.data.updated_at,
          updated_by: resp.data.updated_by
        }))
        toast.success(`Success Update Courier Status ${appData.courierCode} / ${appData.serviceType} / ${appData.serviceCode}`)
      }).catch(err => {
        toast.error(err.response.data.error)
      })

    }


  }

  const retrieveData = async () => {

    await axios.get(`${window.API_HOST}/v1/courier-service-type/${props.uid}`).then(async (res) => {
      const data = res.data.data

      setAppData(prevState => ({
        ...prevState, 
        courierCode: data.courier_code,
        serviceType: data.service_type,
        serviceCode: data.service_code,
        
        updated_at: data.updated_at,
        updated_by: data.updated_by
      }))

    }).catch(err => {
      toast.error(err.response.data.error)
    })
  }

  async function fetchForm() {
    await axios.get(`${window.API_HOST}/v1/courier-service-type/form`)
      .then(res => {
        const resp = res.data;
        setFormData(prevState => ({
          ...prevState,
          mCourier: resp.data.courier ?? [],
          mServiceType: resp.data.service_type ?? []
        }))
      }).catch(err => {

      })
  }

  useEffect(() => {

    fetchForm()
    if (props?.uid) {
      retrieveData()
    }

  }, [props.uid]);


  return (
    <div>
      <Panel className='w-600px'>
        <PanelHeader className="bg-purple-200  p-2 p-r-0" noButton>
          <div className='row'>
            <div className='col-sm-6 fw-bolder fs-2 text-black'>{props.uid ? 'Update' : 'Create'} Courier Service Mapping</div>
            <div className='col-sm-6 align-items-baseline text-end'>
              <div className=''>
                {(true) ? <button className="btn btn-sm btn-primary ms-3 f-s-11 text-center ml-3" onClick={saveAction}><i className="fa fa-save"></i> Save</button> : null}
                {(true) ? <button className="btn btn-sm btn-danger ms-3 f-s-11 text-center ml-3" onClick={props.cancelAction}><i className="fa fa-minus-circle"></i> Close</button> : null}
              </div>

            </div>
          </div>
        </PanelHeader>
        <PanelBody>
          <div className='row'>
            <div className='col-sm-12'>
              <div className="form-group row mb-1">
                <label className="col-sm-3 col-form-label">Courier Code</label>
                <div className="col-sm-9">
                  <Select name="courierCode" placeholder={"Courier"} className=''
                    value={(formData?.mCourier ?? []).find(({ value }) => { return value === appData?.courierCode })}
                    onChange={handleOnChangeSelect}
                    options={formData?.mCourier ?? []}
                    isDisabled={props.uid}
                  />
                </div>
              </div>
              <div className="form-group row mb-1">
                <label className="col-sm-3 col-form-label">Service Type</label>
                <div className="col-sm-9">
                  <Select name="serviceType" placeholder={"ServiceType"} className=''
                    value={(formData?.mServiceType ?? []).find(({ value }) => { return value === appData?.serviceType })}
                    onChange={handleOnChangeSelect}
                    options={formData?.mServiceType ?? []}
                    components={{ Option: CustomOption }}
                    isDisabled={props.uid}
                  />
                </div>
              </div>
              <div className="form-group row mb-1">
                <label className="col-sm-3 col-form-label">Service Code</label>
                <div className="col-sm-9">
                  <input type="text" name="serviceCode" value={appData.serviceCode ?? ''} onChange={handleOnChangeInputText} className="form-control form-control-sm" />
                </div>
              </div>
              <div className="form-group row mt-3">
                <label className="col-sm-3 col-form-label">Updated By </label>
                <div className="col-sm-9 ">
                  <div className='row'>
                    <div className='col-sm-6'>
                      <input type="text" value={appData.updated_by ?? ''} className="form-control form-control-sm" readOnly disabled />
                    </div>
                    <div className='col-sm-6'>
                      <input type="text" value={appData.updated_at ?? ''} className="form-control form-control-sm" readOnly disabled />
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </PanelBody>
      </Panel>
    </div>

  )


}

export default CourierServiceTypeForm